import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { get_provinces } from '../../redux/actions/provinceAction'
import ProvinceDetails from './ProvinceDetails'

const ProvinceListing = () => {
  const dispatch = useDispatch()
  const { provinces } = useSelector(state => state.province)
  const [selectedProvince, setSelectedProvince] = useState(null)
  const [showModal, setShowModal] = useState(false)

  useEffect(() => {
    dispatch(get_provinces())
  }, [])

  const handleViewDetails = (province) => {
    setSelectedProvince(province)
    setShowModal(true)
  }

  const handleCloseModal = () => {
    setShowModal(false)
    setSelectedProvince(null)
  }
  
  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-CA', {
      style: 'currency',
      currency: 'CAD'
    }).format(amount)
  }
   

  return (
    <div className="container py-5">
      {/* <div className="row mb-4">
        <div className="col-12">
          <h1 className="display-4 text-center mb-2">Province Listing</h1>
          <p className="text-center text-muted">Canadian Provincial Rental Regulations</p>
        </div>
      </div> */}

      <div className="row g-4">
          
          <table className="table table-striped table-hover align-middle">
            <thead className="table-primary">
              <tr>
                <th>Province</th>
                <th>Regulatory Body</th>
                <th>Rent Cap (%)</th>
                <th>Notice (Days)</th>
                <th>Filing Fee</th>
                <th>Features</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {provinces?.map((province) => (
                <tr key={province.id}>
                  <td>
                    <strong>{province.name}</strong>
                    <div className="text-muted small">{province.code}</div>
                  </td>

                  <td>
                    <strong>{province.regulatory_body_acronym}</strong>
                    <div className="text-muted small">
                      {province.regulatory_body_name}
                    </div>
                  </td>

                  <td>{province.rent_increase_cap_percentage}%</td>

                  <td>{province.rent_increase_notice_days}</td>

                  <td>{formatCurrency(province.eviction_filing_fee)}</td>

                  <td>
                    <div className="d-flex gap-1 flex-wrap">
                      {province.has_online_dispute_portal && (
                        <span className="badge bg-success">Online Portal</span>
                      )}
                      {province.has_standard_lease_form && (
                        <span className="badge bg-info">Standard Lease</span>
                      )}
                      {province.allows_electronic_service && (
                        <span className="badge bg-warning text-dark">E-Service</span>
                      )}
                    </div>
                  </td>

                  <td>
                    <button
                      className="btn btn-sm btn-primary"
                      onClick={() => handleViewDetails(province)}
                    >
                      View
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

      </div>

      {/* Modal */}
      {showModal && selectedProvince && (
     <ProvinceDetails selectedProvince={selectedProvince} handleCloseModal={handleCloseModal} />
      )}

      <style jsx>{`
        .hover-shadow {
          transition: all 0.3s ease;
        }
        .hover-shadow:hover {
          box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
          transform: translateY(-5px);
        }
        .modal.show {
          background-color: rgba(0, 0, 0, 0.5);
        }
        .card {
          border-radius: 8px;
        }
        .card-header {
          border-radius: 8px 8px 0 0 !important;
        }
      `}</style>
    </div>
  )
}

export default ProvinceListing